<div class="flex h-screen flex-col overflow-hidden">
  <app-header class="shrink-0"></app-header>
  <div class="flex-1 min-h-0">
    <ngx-simplebar #simpleBar class="w-full h-full">
      <app-custom-slide [style.height.px]="slideImgHeight" class="overflow-hidden"></app-custom-slide>
      <app-about #about></app-about>
      <app-partners></app-partners>
      <app-members #members></app-members>
      <app-history #history></app-history>
      <app-news #news></app-news>
      <app-footer></app-footer>
    </ngx-simplebar>
  </div>
</div>

<p-dialog
  [(visible)]="appService.isLanguageMenuOpen"
  [dismissableMask]="true"
  [maximizable]="false"
  [modal]="true"
  [position]="'bottom'"
  [resizable]="false"
  [style]="{
    width: '100%',
    maxHeight: '100%',
    margin: 0,
    borderRadius: '16px 16px 0 0',
    height: '276px',
    background: '#333',
    border: '1px solid var(--p-surface-700)'
  }"
>
  <ng-template #headless>
    <div class="full">
      <div class="w-full h-fit flex justify-end items-center flex-col px-[16px] pt-[8px] gap-[4px]">
        <!--        <div (pointerdown)="onPointerDown($event)" class="w-[48px] h-[4px] bg-[var(&#45;&#45;p-primary-700)] rounded-[999px] cursor-pointer touch-none"></div>-->
        <div class="relative w-full flex justify-between items-center gap-[16px]">
          <div class="w-[36px] h-[36px]"></div>
          <div class="text-[16px] font-medium text-[var(--p-primary-50)]">
            {{ 'home.language-setting' | translate }}
          </div>
          <p-button
            (click)="appService.closeLanguageMenu()"
            [styleClass]="'only-icon-transparent'"
            [style]="{
              width: '36px',
              height: '36px',
              padding: '8px'
            }"
          >
            <img alt="menu" class="w-[20px]" src="/images/common/close-outline.svg" />
          </p-button>
        </div>
      </div>
      <div class="w-full flex flex-col px-[20px] pt-[8px] pb-[32px] gap-[8px]">
        @for (language of appService.languageArr; track language.id) {
          <div
            (click)="appService.changeLanguage(language.id)"
            [class]="language.id === appService.usedLanguage() ? 'bg-[#FFFFFF29]' : ''"
            class="w-full flex justify-center items-center p-[8px] rounded-[8px] text-[16px] text-[var(--p-surface-50)]"
          >
            {{ language.label }}
          </div>
        }
      </div>
    </div>
  </ng-template>
</p-dialog>
